module.exports = __webpack_public_path__ + "static/media/link-grey.574559c2.svg";